import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExpenseDetailsReportService {

  constructor(private http: HttpClient) { }

  exportExpenseDetailsReport(data: any): Observable<any> {
    return this.http.post(
      environment.baseUrl + '/shop/reports/expense-details-report',
      data,
      { responseType: 'blob' }
    );
  }
  getExpenseTypeList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/shop/expense-type/get', requestData);

  }
   getUsers(): Observable<any>{
    let search={"search":{"filters":{"column":[],"scope":{"limit":1000,"offset":0}},"sort":[]}};
    return this.http.post(environment.baseUrl+'/user/get', search);
  }


}
